<template>
  <div class="candidate-list-toolbar">
    <div class="candidate-list-toolbar__filter-bar pa-4 pb-3">
      <v-text-field
        :model-value="search"
        :label="$t('candidates.search')"
        clearable
        hide-details
        prepend-inner-icon="mdi-magnify"
        class="candidate-list-toolbar__filter-search"
        @update:model-value="emitSearch"
      />
      <v-btn
        variant="outlined"
        color="primary"
        prepend-icon="mdi-filter-variant"
        @click="$emit('open-filters')"
      >
        {{ $t("candidates.filtersButton") }}
        <span v-if="activeFiltersCount" class="ml-1">({{ activeFiltersCount }})</span>
      </v-btn>
      <NcrmSegmentedControl
        :model-value="viewMode"
        :items="viewItems"
        :aria-label="$t('candidates.view.ariaLabel')"
        class="candidate-list-toolbar__view-toggle"
        @update:model-value="$emit('update-view-mode', $event)"
      />
    </div>

    <template v-if="activeChips.length">
      <v-divider />
      <div class="candidate-list-toolbar__chipbar px-4 py-2">
        <div class="candidate-list-toolbar__chips">
          <v-chip
            v-for="chip in activeChips"
            :key="chip.key"
            closable
            @click:close="$emit('remove-filter', chip)"
          >
            {{ chip.label }}
          </v-chip>
          <v-btn variant="text" size="small" @click="$emit('reset-filters')">
            {{ $t("candidates.filters.clearAll") }}
          </v-btn>
        </div>
        <div class="candidate-list-toolbar__results">
          {{ resultsCount }} {{ $t("candidates.results") }}
        </div>
      </div>
    </template>

    <v-divider />
  </div>
</template>

<script>
import { defineComponent } from "vue";
import NcrmSegmentedControl from "@/components/ncrm/shared/NcrmSegmentedControl.vue";

export default defineComponent({
  name: "CandidateListToolbar",
  components: {
    NcrmSegmentedControl,
  },
  props: {
    search: { type: String, default: "" },
    viewMode: { type: String, default: "cards" },
    viewItems: { type: Array, default: () => [] },
    activeChips: { type: Array, default: () => [] },
    activeFiltersCount: { type: Number, default: 0 },
    resultsCount: { type: Number, default: 0 },
  },
  emits: [
    "update-search",
    "update-view-mode",
    "open-filters",
    "remove-filter",
    "reset-filters",
  ],
  methods: {
    emitSearch(value) {
      this.$emit("update-search", value == null ? "" : String(value));
    },
  },
});
</script>

<style scoped>
.candidate-list-toolbar__filter-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 12px;
}
.candidate-list-toolbar__filter-search {
  flex: 1 1 280px;
}
.candidate-list-toolbar__view-toggle {
  margin-left: auto;
}
.candidate-list-toolbar__chipbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
}
.candidate-list-toolbar__chips {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px;
}
.candidate-list-toolbar__results {
  font-size: 0.85rem;
  color: rgba(var(--v-theme-on-surface), 0.6);
  white-space: nowrap;
}
</style>
